import {
  React,
  Component,
  withCookies,
  axios,
  routes,
} from 'imports/CommonImports';

import {
  Validation
} from 'imports/ComponentsImports';

import {
  PrimaryColor1,
  GreyColor1,
  GreyColor2,
  style,
} from 'imports/DesignImports';

import {
  Paper,
  CircularProgress,
} from 'material-ui';

import {
  SwapVert,
} from 'imports/IconsImports';

const styles = {
  header: {
    color: PrimaryColor1,
    backgroundColor: GreyColor1,
    padding: '10px',
  },
  list: {
    color: PrimaryColor1,
    backgroundColor: GreyColor2,
    padding: '10px',
  },
  date:{
    fontSize: '0.8em',
    fontStyle: 'italic',
  },
  cellHeader: (size) => {return {
    flex: size,
    fontWeight: 700,
    marginRight: '10px',
    marginLeft: '10px'
  }},
  cellRow: (size) => {return {
    flex: size,
    marginRight: '10px',
    marginLeft: '10px'
  }}
}

const rowStyle = style({
  backgroundColor: GreyColor2 + " !important;",
  $nest: {
    '&:hover': {
      backgroundColor: GreyColor1 + " !important;"
    }
  }
});

class ProjectsList extends Component {
  constructor(props){
    super(props)
    this.state = {
      projects: null,
      loading: true,
      error: false,
      reverseSort: {"name":false, "area": false, "leader": false, "state": false},
      token:this.props.cookies.get('token'),
      user: this.props.cookies.get('user'),
    }
  }

  componentDidMount() {
    this.getProjects();
  }

  render() {
    if(this.state.error){
      return(
        <div style={{display: 'flex', justifyContent: 'center', marginTop:'20px'}}>
          <p>Error al cargar los proyectos. Por favor recarga la página o intenta más tarde.</p>
        </div>
      )
    }
    if(this.state.loading){
      return(
          <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center', marginTop:'20px'}}>
            <CircularProgress color='#9e9e9e' size={80} thickness={5} />
          </div>
      )
    }
    return(
      <div>
        {this.projectHeader()}
        {this.state.projects.map((project, i) => {return this.projectRow(project,i)})}
      </div>
    );
  }

  projectHeader = (project) => {
    return(
      <Paper style={styles.header} zDepth={1} rounded={false}>
        <div style={{display:'flex', alignItems: 'center'}}>
          <div style={styles.cellHeader(1.5)}>Nombre Proyecto {this.printSort("name")}</div>
          <div style={styles.cellHeader(1)}>Área {this.printSort("area")}</div>
          <div style={styles.cellHeader(1)}>Líder {this.printSort("leader")}</div>
          <div style={styles.cellHeader(1)}>Estado Ficha {this.printSort("state")}</div>
          <div style={styles.cellHeader(1)}>Proceso de Validación</div>
        </div>
      </Paper>
    );
  }

  projectRow = (project, i) => {
    var row = (
      <Paper style={styles.list} zDepth={1} rounded={false} className={rowStyle}>
        <div style={{display:'flex'}}>
          <div style={styles.cellRow(1.5)}>{project.information.name}<br/><span style={styles.date}>Actualizado: {(new Date(project.updated_at)).toLocaleString()}</span></div>
          <div style={styles.cellRow(1)}>{project.information.area.name}</div>
          <div style={styles.cellRow(1)}>{project.information.leader_first_name + " " + project.information.leader_last_name}</div>
          <div style={styles.cellRow(1)}>{project.state[0].state}</div>
          <div style={styles.cellRow(1)}><Validation project={project} /></div>
        </div>
      </Paper>
  )
    if(this.state.user.position === 'Líder de proyecto' || project.information.leader_email === this.state.user.email || project.state[0].state === 'En proceso de firma')
      return(
        <a key={i} href={"/project/"+project.id} style={{textDecoration:'none'}}>
          {row}
        </a>
      );
    else {
      return row;
    }
  }

  getProjects = () => {
    var connection = axios.create({
      baseURL: routes.host,
      headers: {'Authorization': "Token "+ this.state.token}
    });
    connection.get(routes.projectFullInformation)
      .then((response) => {
        console.log({response});
        
        this.setState({
          projects: response.data.filter((project) => {return project.state.length > 0 && (project.state[0].state === "En desarrollo" || project.state[0].state === "No trazable" || project.state[0].state === "En proceso de firma" || project.state[0].state === "Ficha aprobada")}),
          loading: false,
          error:false
        })
      })
      .catch((error) => {
        console.log(error);
        this.setState({ error: true, loading: false })
      });
  }

  printSort(column){
    if(column==="name"){
      return <SwapVert onClick={()=>this.orderBy("name")} style={{cursor: 'pointer'}} />
    }
    if(column==="area"){
      return <SwapVert onClick={()=>this.orderBy("area")} style={{cursor: 'pointer'}} />
    }
    if(column==="leader"){
      return <SwapVert onClick={()=>this.orderBy("leader")} style={{cursor: 'pointer'}} />
    }
    if(column==="state"){
      return <SwapVert onClick={()=>this.orderBy("state")} style={{cursor: 'pointer'}} />
    }
  }

  orderBy = (column) => {
    var projects = this.state.projects;
    var reverseSort = this.state.reverseSort;

    if(column==="name"){
      if(reverseSort.name===false){
        projects.sort((a, b) => a.information.name.localeCompare(b.information.name));
      } else {
        projects.sort((a, b) => -1*(a.information.name.localeCompare(b.information.name)));
      }
      reverseSort.name = !reverseSort.name;
    }

    if(column==="area"){
      if(reverseSort.area===false){
        projects.sort((a, b) => a.information.area.name.localeCompare(b.information.area.name));
      } else {
        projects.sort((a, b) => -1*(a.information.area.name.localeCompare(b.information.area.name)));
      }
      reverseSort.area = !reverseSort.area;
    }

    if(column==="leader"){
      if(reverseSort.leader===false){
        projects.sort((a, b) => (a.information.leader_first_name+" "+a.information.leader_last_name).localeCompare((b.information.leader_first_name+" "+b.information.leader_last_name)));
      } else {
        projects.sort((a, b) => -1*((a.information.leader_first_name+" "+a.information.leader_last_name).localeCompare((b.information.leader_first_name+" "+b.information.leader_last_name))));
      }
      reverseSort.leader = !reverseSort.leader;
    }

    if(column==="state"){
      if(reverseSort.state===false){
        projects.sort((a, b) => a.state[0].state.localeCompare(b.state[0].state));
      } else {
        projects.sort((a, b) => -1*(a.state[0].state.localeCompare(b.state[0].state)));
      }
      reverseSort.state = !reverseSort.state;
    }

    this.setState({projects: projects, reverseSort: reverseSort});
  }

}

export default withCookies(ProjectsList);



// WEBPACK FOOTER //
// ./src/components/files/ProjectsList.js